import {baseUrl} from './env'
import axios from 'axios';
import {Loading, Message} from 'element-ui';
import store from '../store';
import router from '../router'

// 创建axios实例
const service = axios.create({
    withCredentials: true,
    baseURL: baseUrl, // api的base_url
    timeout: 50000                  // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
    // Do something before request is sent
    if (store.getters.token) {
        config.headers['X-Token'] = store.getters.token; // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    }
    return config;
}, error => {
    // Do something with request error
    Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(response => {
    // 对响应数据做点什么
    if (typeof(response.data.resultCode) != undefined && response.data.resultCode == -2001) {
        router.replace({
            path: '/',
            query: {redirect: router.currentRoute.fullPath}
        })
    }
    if(response.data.resultCode === 0 || response.data.resultCode === 403){
        Message({
            message: response.data.resultMsg,
            type: 'error',
            duration: 5 * 1000
        });
        return Promise.reject({});
    } else {
        return response;
    }
}, error => {
    // Do something with response error
    //console.log(error);
    Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
    });
    return Promise.reject(error);
});

export default service;



// WEBPACK FOOTER //
// ./src/config/fetch.js